export default __webpack_public_path__ + "static/media/button_singpass.bb525329.svg";